export { FooterSection } from './FooterSection';
